import React from 'react';
import './UtilityCard.css';

interface UtilityCardProps {
    problem?: string;
    solution?: string;
    productName?: string;
    productUrl?: string;
    productImageUrl?: string;
    sourceSubreddit?: string;
}

const UtilityCard: React.FC<UtilityCardProps> = ({
    problem,
    solution,
    productName,
    productUrl,
    productImageUrl,
    sourceSubreddit,
}) => {
    if (!problem && !solution && !productName) return null;

    const attributionText = sourceSubreddit
        ? `Based on r/${sourceSubreddit} consensus`
        : 'Based on Reddit community consensus';

    return (
        <div className="utility-card" id="utility-card">
            <div className="utility-card-header">
                <span className="utility-card-badge">Quick Verdict</span>
                <span className="utility-card-attribution">{attributionText}</span>
            </div>
            <div className="utility-card-content">
                <div className="utility-main-grid">
                    <div className="utility-text-section">
                        {problem && (
                            <div className="utility-item problem">
                                <div className="item-header">
                                    <span className="item-icon">❓</span>
                                    <h3>The Problem</h3>
                                </div>
                                <p>{problem}</p>
                            </div>
                        )}
                        {solution && (
                            <div className="utility-item solution">
                                <div className="item-header">
                                    <span className="item-icon">✅</span>
                                    <h3>The Consensus</h3>
                                </div>
                                <p>{solution}</p>
                            </div>
                        )}
                    </div>

                    {productName && (
                        <div className="utility-product-section">
                            <div className="product-card">
                                <div className="product-header">Recommended Tool</div>
                                {productImageUrl && (
                                    <div className="product-media">
                                        <img src={productImageUrl} alt={productName} />
                                    </div>
                                )}
                                <div className="product-details">
                                    <h4>{productName}</h4>
                                    {productUrl && (
                                        <a
                                            href={productUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="amz-button"
                                        >
                                            Check Price on Amazon
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UtilityCard;
